module.exports = __webpack_public_path__ + "img/temp-heater-off.ba72e3d0.svg";